import { queryOptions, useQuery } from '@tanstack/react-query'

import * as apiClient from '@/lib/api'
import { ROLES } from "@/lib/auth/roles";
import { useToken } from "@/stores/token";
import { Token } from "@/types/token";
import { LOCAL_STORAGE_KEY_SERVICE_TYPE_FILTER, QUERY_KEY_PRIMARY_SERVICE_TYPE } from '@/utils/keys'

export interface ApiServiceType {
  service_type_id: number | null,
}

function fetchPrimaryServiceType(): Promise<ApiServiceType> {
  return apiClient.get(`/firm/primary-service-type`)
}

type PrimaryServiceTypeQueryOptionsParams = {
  setDefaultServiceTypeState: (serviceType: number) => void,
  token: Token | null
}

export const primaryServiceTypeQueryOptions = ({setDefaultServiceTypeState, token}: PrimaryServiceTypeQueryOptionsParams) => {
  // eslint-disable-next-line @tanstack/query/exhaustive-deps
  return queryOptions({
    queryKey: [QUERY_KEY_PRIMARY_SERVICE_TYPE],
    queryFn: async () => {
      const localStorageServiceType = localStorage.getItem(LOCAL_STORAGE_KEY_SERVICE_TYPE_FILTER)
      if (localStorageServiceType) {
        return {service_type_id: Number(localStorageServiceType)}
      }

      const data = await fetchPrimaryServiceType()

      if (data?.service_type_id !== null) {
        setDefaultServiceTypeState(data.service_type_id)
      }

      return data
    },
    staleTime: Infinity,
    refetchOnReconnect: false,
    enabled: !!token && !token?.roles.includes(ROLES.IS_AUTHENTICATED_2FA_IN_PROGRESS),
  })
}

export const usePrimaryServiceType = (setDefaultServiceTypeState: (serviceType: number) => void) => {
  const { token } = useToken()

  return useQuery(primaryServiceTypeQueryOptions({setDefaultServiceTypeState, token}))
}